import { Link } from "react-router-dom";
import { IReportSectionProps } from "./ReportSection";

export const View = (props: IReportSectionProps) => {
  return (
    <Link to={props.targetUrl} className="report-section--link">
      <div className="boxs">
        <h4>
          <img src={props.iconSource} alt="icon" />
          {props.title}
        </h4>
        <p>{props.description}</p>
      </div>
    </Link>
  );
};
